import {
  accountType,
  bookingType,
  contactNoteType,
  contactRelationType,
  contactStage,
  contactType,
  expenseRecurrenceType,
  expenseType,
  incomeType,
  ktgType,
  projectStatusType,
  projectType,
  salaryType,
  transferType,
  userGender,
  userRoles,
} from '@/db/schema'
import { entryStatus } from '@/db/schema/_types'

const strEnum = <T extends string>(o: T[]): { [K in T]: K } => {
  return o.reduce((res, key) => {
    res[key] = key
    return res
  }, Object.create(null))
}

export const AccountType = strEnum(accountType.enumValues)
export type AccountTypeValue = keyof typeof AccountType

export const ContactStageType = strEnum(contactStage.enumValues)
export type ContactStageTypeValue = keyof typeof ContactStageType

export const ContactType = strEnum(contactType.enumValues)
export type ContactTypeValue = keyof typeof ContactType

export const ContactRelationType = strEnum(contactRelationType.enumValues)
export type ContactRelationTypeValue = keyof typeof ContactRelationType

export const ContactNoteType = strEnum(contactNoteType.enumValues)
export type ContactNoteTypeValue = keyof typeof ContactNoteType

export const BookingType = strEnum(bookingType.enumValues)
export type BookingTypeValue = keyof typeof BookingType

export const EntryStatusType = strEnum(entryStatus.enumValues)
export type EntryStatusTypeValue = keyof typeof EntryStatusType

export const KtgType = strEnum(ktgType.enumValues)
export type KtgValue = keyof typeof KtgType

export const ExpenseType = strEnum(expenseType.enumValues)
export type ExpenseTypeValue = keyof typeof ExpenseType

export const TransferType = strEnum(transferType.enumValues)
export type TransferTypeValue = keyof typeof TransferType

export const SalaryType = strEnum(salaryType.enumValues)
export type SalaryTypeValue = keyof typeof SalaryType

export const ExpenseRecurrenceType = strEnum(expenseRecurrenceType.enumValues)
export type ExpenseRecurrenceTypeValue = keyof typeof ExpenseRecurrenceType

export const UserRolesType = strEnum(userRoles.enumValues)
export type UserRolesTypeValue = keyof typeof UserRolesType

export const UserGenderType = strEnum(userGender.enumValues)
export type UserGenderTypeValue = keyof typeof UserGenderType

export const ProjectStatusType = strEnum(projectStatusType.enumValues)
export type ProjectStatusTypeValue = keyof typeof ProjectStatusType

export const ProjectType = strEnum(projectType.enumValues)
export type ProjectTypeValue = keyof typeof ProjectType

export const IncomeType = strEnum(incomeType.enumValues)
export type IncomeTypeValue = keyof typeof IncomeType
